import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export const SearchInput = (props: {
  variant: 'sidebar' | 'standard';
  searchTerm: string;
  placeholder: string;
  onChange: (searchTerm: string) => void;
}) => {

  return (
    <TextField
      className={props.variant === 'standard' ? 'bhvk-list-search-input' : 'sidebar-search-input'}
      label=""
      placeholder={props.placeholder}
      variant="outlined"
      color="info"
      fullWidth
      value={props.searchTerm}
      onChange={(e) => props.onChange(e.target.value)}
      size="small"
      InputProps={{
        ...(props.variant === 'standard'
          ? {
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon color="disabled" />
              </InputAdornment>
            ),
          }
          : {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }),
      }}
    />
  );

};
